import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
var _hoisted_1 = {
  style: {
    "display": "flex",
    "width": "100%"
  }
};
var _hoisted_2 = {
  style: {
    "flex": "1"
  }
};
var _hoisted_3 = {
  style: {
    "display": "flex",
    "width": "100%",
    "justify-content": "space-between"
  }
};
var _hoisted_4 = {
  class: "dialog-footer"
};
import { reactive, ref, watch, watchEffect } from "vue";
import { set_business, sales_area, client, get_business, get_client_project } from "@/api/apis";
import { useUserStore } from "@/store/user";
import { ElMessage } from "element-plus";
import _ from "lodash";
import { useDicStore } from "@/store/dictionary";
import { useProductStore } from "@/store/product";
import { getTree, de_weight } from "@/util/index";
export default {
  __name: 'addBusinessDailog',
  props: ["id", "isShow", "info", "goods"],
  emits: ["close", "onSetSuccess"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var disStore = useDicStore();
    var product_store = useProductStore();
    var props = __props;
    var emit = __emit;
    var userStore = useUserStore();
    var ruleFormRef = ref(null);
    var default_client = {
      opportunity_status: "跟进中",
      // 状态
      address: "",
      country: "",
      business_type: 2,
      clent_user_id: "",
      company: "",
      demand: "",
      // 客户需求
      email: "",
      // 邮箱
      goods_ids_list: [],
      // 感兴趣的商品
      income: "",
      name: "",
      // 联系人姓名
      phone: "",
      // 联系人手机号
      sales_dept_id: "",
      solution: "",
      // 解决方案
      source: "",
      // 内部活动
      title: "",
      // 项目名称
      trade: "",
      // 行业
      userid: "",
      signing_time: "",
      // 签单时间
      client_project_id: null
      //   sale_user: "", //销售员
      //   goods_ids_list: [],
      //   images: [],
      //   trade: "", //行业
      //   email: "", //联系人邮箱
      //   company: "",
      //   phone: "", //联系人手机号
      //   business_type: "1", // 类型 默认1=线索 2=商机 3=报价
      //   title: "", // 项目名称
      //   source: "", // 来源
      //   clent_user_id: "", // 联系人
      //   name: "", //联系人姓名
      //   thread_status: "", // 线索状态 1=未转化 2=已转商机 3=关闭
      //   address: "", // 地址
      //   remark: "", // 备注
      //   sales_dept_id: "",
    };
    var form = ref();
    form.value = Object.assign({}, default_client);

    /**
     * 关联商品
     */
    var goods_list = ref([]);
    var goods_list_temp = ref([]);
    var goods_list_temp2 = ref([]);
    watch(() => {
      return props.goods;
    }, val => {
      goods_list.value = _.cloneDeep(val);
      goods_list_temp.value = _.cloneDeep(val);
      goods_list_temp2.value = _.cloneDeep(val);
      // console.log("打印商品列表=====", goods_list.value);
    });
    var countIncome = data => {
      var total = 0;
      data.map(item => {
        console.log("item", item);
        if (item.income) {
          total += parseFloat(item.income);
        }
      });
      form.value.income = parseFloat(total).toFixed(2);
      console.log("income:" + form.value.income);
    };
    var handle_goods = val => {
      // console.log("在客户中收到的商品修改的回调===&&&", val);
      // goods_list.value = val;
      // console.log("去重去重=====", de_weight(val));
      goods_list.value = de_weight(val);
      countIncome(goods_list.value);
    };
    var dicStore = useDicStore();
    var lost_reason_list = [];
    dicStore.get_dic("丢单原因").then(res => {
      lost_reason_list = res;
    });
    var rules = {
      thread_status: [{
        required: "true",
        message: "请选择线索状态",
        trigger: ["blur", "change"]
      }],
      lost_order_reason: [{
        required: "true",
        message: "请选择线丢单原因",
        trigger: ["blur", "change"]
      }],
      client_project_id: [{
        required: "true",
        message: "请选择客户项目",
        trigger: ["blur", "change"]
      }],
      title: [{
        required: "true",
        message: "请输入主题",
        trigger: ["blur", "change"]
      }],
      company: [{
        required: "true",
        message: "请输入客户",
        trigger: ["blur", "change"]
      }],
      sale_user: [{
        required: "true",
        message: "请设置销售员",
        trigger: ["blur", "change"]
      }],
      sales_dept_id: [{
        required: "true",
        message: "请选择销售区域",
        trigger: ["blur", "change"]
      }],
      name: [{
        required: "true",
        message: "请选择或输入联系人",
        trigger: ["blur", "change"]
      }],
      phone: [{
        required: "true",
        message: "请输入手机号",
        trigger: ["blur", "change"]
      }],
      income: [{
        required: "true",
        message: "请输入预计收入",
        trigger: ["blur", "change"]
      }],
      signing_time: [{
        required: "true",
        message: "请选择签单时间",
        trigger: ["blur", "change"]
      }]
    };

    /**
     * 弹窗的展示与关闭
     */
    var dialogVisible = ref(false);
    var is_show_dialog = ref(false);
    watch(() => {
      return is_show_dialog.value;
    }, val => {
      if (!val) {
        key_word.value = "";
      }
    });
    watchEffect(() => {
      dialogVisible.value = props.isShow;
    });
    watch(() => {
      return dialogVisible.value;
    }, () => {
      if (!dialogVisible.value) {
        form.value = Object.assign({}, default_client);
        dic_data.sales_area_list = []; // 销售区域
        client_contracts_list.value = [];
        ruleFormRef.value.resetFields();
        goods_list.value = [];
        goods_list_temp.value = [];
        goods_list_temp2.value = [];
        emit("close");
      } else {
        props.info && init_from();
        console.log(props.info);
      }
    });

    // watch(
    //   () => {
    //     return form.value.birthday;
    //   },
    //   (val) => {
    //     console.log("获取的生日是", form.value.birthday);
    //   }
    // );

    /**
     * 编辑客户，初始化数据
     */

    var init_from = () => {
      get_business({
        id: props.info.id
      }).then(res => {
        if (res.code == 200) {
          var _obj$user_info, _obj$user_info2, _obj$client_user_info, _obj$client_user_info2, _obj$client_user_info3, _obj$client_info, _form$value, _obj$user_info3;
          var obj = props.info.id ? _.cloneDeep(res.data.list[0]) : props.info;
          console.log(obj);
          Object.keys(form.value).map(x => {
            if (obj.hasOwnProperty(x) && x != "sales_dept_id") {
              form.value[x] = obj[x];
            }
          });
          form.value.sale_user = (_obj$user_info = obj.user_info) === null || _obj$user_info === void 0 ? void 0 : _obj$user_info.name;
          form.value.userid = (_obj$user_info2 = obj.user_info) === null || _obj$user_info2 === void 0 ? void 0 : _obj$user_info2.id;
          form.value.email = props.info.id ? obj.client_user_email : (_obj$client_user_info = obj.client_user_info) === null || _obj$client_user_info === void 0 ? void 0 : _obj$client_user_info.email;
          form.value.phone = props.info.id ? obj.client_user_phone : (_obj$client_user_info2 = obj.client_user_info) === null || _obj$client_user_info2 === void 0 ? void 0 : _obj$client_user_info2.phone;
          form.value.name = props.info.id ? obj.client_user_name : (_obj$client_user_info3 = obj.client_user_info) === null || _obj$client_user_info3 === void 0 ? void 0 : _obj$client_user_info3.name;
          form.value.company = props.info.id ? obj.client_name : (_obj$client_info = obj.client_info) === null || _obj$client_info === void 0 ? void 0 : _obj$client_info.company;
          form.value["trade"] = obj.client_trade;
          form.value["goods_ids_list"] = [];
          form.value["lost_order_reason"] = obj.lost_order_reason;
          form.value["lost_order_remark"] = obj.lost_order_remark;
          form.value["activity_name"] = obj.activity_name;
          form.value.client_project_id = obj.client_project_id;
          form.value.client_id = obj.client_id;
          if (!obj.goods_ids_list) {
            obj.goods_ids_list = [];
          }
          if (!obj.class_ids_list) {
            obj.class_ids_list = [];
          }
          goods_list.value = _.cloneDeep([...obj.goods_ids_list, ...obj.class_ids_list]);
          goods_list_temp.value = _.cloneDeep([...obj.goods_ids_list, ...obj.class_ids_list]);
          goods_list_temp2.value = _.cloneDeep([...obj.goods_ids_list, ...obj.class_ids_list]);
          console.log(goods_list.value);
          if ((_form$value = form.value) !== null && _form$value !== void 0 && _form$value.client_id) {
            getClientProjects(form.value.client_id);
            cur_client_id.value = form.value.client_id;
          }
          get_sale_area((_obj$user_info3 = obj.user_info) === null || _obj$user_info3 === void 0 ? void 0 : _obj$user_info3.id, () => {
            form.value.sales_dept_id = Number(obj.sales_dept_id);
          });
          client({
            company: form.value.company
          }).then(res => {
            if (res.code == 200 && form.value.company && res.data.list && res.data.list.length != 0) {
              client_contracts_list.value = res.data.list[0].client_users; // 获取主要联系人
              if (!props.info.id) {
                goods_list.value = _.cloneDeep([...res.data.list[0].goods_ids_list, ...res.data.list[0].class_ids_list]);
                goods_list_temp.value = _.cloneDeep([...goods_list.value]);
              }
            }
          });
        }
      });

      // console.log("商机中的初始化后的数据是====",form.value);
    };

    /**
     * 选择客户
     */
    var data_type = ref(""); // 进行选择数据的字段
    var key_word = ref(""); // 关键字查询

    var client_contracts_list = ref([]); // 当前选中客户的联系人列表

    var select_data = val => {
      data_type.value = val;
      is_show_dialog.value = true;
    };
    //获取客户项目
    var client_project_list = ref([]);
    var getClientProjects = function getClientProjects(id) {
      var is_default = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      get_client_project({
        client_id: id
      }).then(res => {
        if (res.code == 200) {
          client_project_list.value = res.data || [];
          if (is_default) {
            var _client_project_list$;
            form.value.client_project_id = (_client_project_list$ = client_project_list.value[0]) === null || _client_project_list$ === void 0 ? void 0 : _client_project_list$.id;
          }
        }
      });
    };
    var showDialog = ref(false);
    //新增客户项目
    var addClientProject = () => {
      if (!form.value.company) {
        ElMessage({
          type: "error",
          message: "请先选择客户"
        });
        return;
      }
      showDialog.value = true;
    };
    var handle_close_client = type => {
      showDialog.value = false;
      getClientProjects(cur_client_id.value, type == "add" ? true : false);
    };
    var cur_client_id = ref(null);
    var get_select_item = val => {
      if (!val.client_level) {
        ElMessage({
          type: "error",
          message: "请先维护客户类型"
        });
        return;
      }
      is_show_dialog.value = false;
      console.log("选择的客户==", val);
      if (data_type.value == "客户") {
        if (val.company != form.value.company) {
          var _val$user_info, _val$contact_person_i, _val$contact_person_i2, _val$user_info2, _val$user_info3;
          form.value.company = val.company;
          form.value.trade = val.trade;
          form.value.address = val.address;
          form.value.country = val.country;
          form.value.email = val.email;
          form.value.sale_user = ((_val$user_info = val.user_info) === null || _val$user_info === void 0 ? void 0 : _val$user_info.name) || "";
          client_contracts_list.value = val.client_users || [];
          form.value.name = ((_val$contact_person_i = val.contact_person_info) === null || _val$contact_person_i === void 0 ? void 0 : _val$contact_person_i.name) || "";
          form.value.phone = ((_val$contact_person_i2 = val.contact_person_info) === null || _val$contact_person_i2 === void 0 ? void 0 : _val$contact_person_i2.phone) || "";
          form.value.userid = (_val$user_info2 = val.user_info) === null || _val$user_info2 === void 0 ? void 0 : _val$user_info2.id;
          goods_list.value = _.cloneDeep(goods_list_temp2.value);
          goods_list.value.push(...val.class_ids_list, ...val.goods_ids_list);
          // console.log("打印good_list.value******************", goods_list.value);
          goods_list.value.map(item => {
            item.income = item.price || "";
            item.completion_rate = item.completion_rate || "";
          });
          countIncome(goods_list.value);
          get_sale_area((_val$user_info3 = val.user_info) === null || _val$user_info3 === void 0 ? void 0 : _val$user_info3.id, () => {
            form.value.sales_dept_id = Number(val.sales_dept_id) || "";
          });
          getClientProjects(val.id, true);
          cur_client_id.value = val.id;
        }
      }
    };

    /**
     * 选择联系人
     */
    watch(() => {
      return form.value.name;
    }, val => {
      if (client_contracts_list.value && client_contracts_list.value.length != 0) {
        var item = client_contracts_list.value && client_contracts_list.value.find(x => x.name == val);
        // console.log("选择的联系人是", item);
        if (item) {
          form.value.phone = item.phone;
          form.value.clent_user_id = item.id;
        } else {
          form.value.clent_user_id = "";
          form.value.phone = "";
        }
      }
    });

    /**
     * 提交
     */
    var onSubmit = () => {
      ruleFormRef.value.validate(valid => {
        if (valid) {
          // form.value.salename = dic_data.sales_user_list.find(
          //   (x) => x.id == form.value.userid
          // )?.name;
          var obj = _.cloneDeep(form.value);
          // goods_ids_list

          var method = "post";
          if (props.id) {
            obj.id = props.id;
          }
          var count = 0;
          obj.goods_ids_list = goods_list.value && goods_list.value.filter(x => x.category).map(x => {
            if (!x.completion_rate) {
              count += 1;
            }
            return {
              id: x.id,
              income: x.income,
              completion_rate: x.completion_rate
            };
          }) || [];
          obj.class_ids_list = goods_list.value && goods_list.value.filter(x => !x.category).map(x => {
            if (!x.completion_rate) {
              count += 1;
            }
            return {
              id: x.id,
              income: x.income,
              completion_rate: x.completion_rate
            };
          }) || [];
          obj.signing_time = Object.prototype.toString.call(obj.signing_time) == "[object Date]" ? obj.signing_time.toLocaleString() : obj.signing_time;
          delete obj.sale_user;
          console.log("打印obj===", obj);
          if (count > 0) {
            ElMessage({
              type: "warning",
              message: "成单率不能为空"
            });
            return;
          }
          set_business(obj, method).then(res => {
            if (res.code == 200) {
              ElMessage({
                type: "success",
                message: props.id ? "编辑商机成功" : "新增商机成功"
              });
              dialogVisible.value = false;
              emit("onSetSuccess");
            }
          });
        }
      });
    };

    /**
     * 数据字典
     */
    var dic_data = reactive({
      sales_area_list: [],
      // 销售区域
      // thread_status_list: [], //线索状态
      status_list: [],
      source_list: [],
      // 线索来源
      trade_list: [] // 行业
    });
    var visit_list = ref("");
    // disStore.get_dic("线索状态").then((res) => {
    //   dic_data.thread_status_list = res;
    // });
    disStore.get_dic("线索来源").then(res => {
      dic_data.source_list = res;
    });
    disStore.get_dic("行业").then(res => {
      dic_data.trade_list = res;
    });
    disStore.get_dic("商机状态").then(res => {
      dic_data.status_list = res;
    });
    /**
     *
     * 销售区域
     */

    var get_sale_area = function get_sale_area(id) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      if (!id) {
        return false;
      }
      sales_area({
        interface: "get_user_data_auth_detail",
        group_type: 1,
        userid: id,
        page: 1,
        limit: 240
      }).then(res => {
        if (res.code == 200) {
          dic_data.sales_area_list = Object.values(res.data.list);
          if (cb) {
            cb();
          }
        }
      });
    };
    var price_input = val => {
      // console.log("val", val.target.value);
      form.value.income = Number(val.target.value).toFixed(2);
    };
    return (_ctx, _cache) => {
      var _component_el_option = _resolveComponent("el-option");
      var _component_el_select = _resolveComponent("el-select");
      var _component_el_form_item = _resolveComponent("el-form-item");
      var _component_el_col = _resolveComponent("el-col");
      var _component_el_input = _resolveComponent("el-input");
      var _component_el_button = _resolveComponent("el-button");
      var _component_el_date_picker = _resolveComponent("el-date-picker");
      var _component_el_row = _resolveComponent("el-row");
      var _component_el_form = _resolveComponent("el-form");
      var _component_good_list_table = _resolveComponent("good-list-table");
      var _component_el_dialog = _resolveComponent("el-dialog");
      var _component_select_data = _resolveComponent("select-data");
      var _component_client_project_dialog = _resolveComponent("client-project-dialog");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => dialogVisible.value = $event),
        title: __props.id ? '编辑商机' : '新增商机',
        style: {
          "width": "80%"
        }
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_4, [_createVNode(_component_el_button, {
          onClick: _cache[20] || (_cache[20] = $event => dialogVisible.value = false)
        }, {
          default: _withCtx(() => _cache[43] || (_cache[43] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: onSubmit,
          color: "#248f83"
        }, {
          default: _withCtx(() => _cache[44] || (_cache[44] = [_createTextVNode(" 确定 ")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          model: form.value,
          "label-position": "right",
          rules: rules,
          "label-width": "110px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[23] || (_cache[23] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "商机状态"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: form.value.opportunity_status,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.opportunity_status = $event),
                  class: "m-2",
                  placeholder: "",
                  filterable: "",
                  style: {
                    "width": "100%"
                  }
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dic_data.status_list, (item, index) => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: index,
                      value: item.full_name,
                      label: item.full_name
                    }, null, 8, ["value", "label"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), form.value.opportunity_status == '丢单' ? (_openBlock(), _createBlock(_component_el_col, {
              key: 0,
              span: 12
            }, {
              default: _withCtx(() => [_cache[24] || (_cache[24] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "丢单原因",
                prop: "lost_order_reason"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: form.value.lost_order_reason,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.lost_order_reason = $event),
                  class: "m-2",
                  placeholder: "",
                  filterable: "",
                  style: {
                    "width": "100%"
                  }
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(lost_reason_list), (item, index) => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: index,
                      value: item.full_name,
                      label: item.full_name
                    }, null, 8, ["value", "label"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true), form.value.opportunity_status == '丢单' ? (_openBlock(), _createBlock(_component_el_col, {
              key: 1,
              span: 12
            }, {
              default: _withCtx(() => [_cache[25] || (_cache[25] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "丢单描述"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.lost_order_remark,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.lost_order_remark = $event),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[27] || (_cache[27] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "客户",
                prop: "company"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
                  modelValue: form.value.company,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.company = $event),
                  autocomplete: "off",
                  disabled: "",
                  format: "YYYY-MM-DD HH:mm",
                  "value-format": "YYYY-MM-DD HH:mm",
                  style: {
                    "width": "100%"
                  }
                }, null, 8, ["modelValue"])]), _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[4] || (_cache[4] = $event => select_data('客户')),
                  color: "#248f83"
                }, {
                  default: _withCtx(() => _cache[26] || (_cache[26] = [_createTextVNode("选择")])),
                  _: 1
                })])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[28] || (_cache[28] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "客户项目",
                prop: "client_project_id"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_select, {
                  modelValue: form.value.client_project_id,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.value.client_project_id = $event),
                  filterable: "",
                  placeholder: "请选择客户项目",
                  style: {
                    "width": "90%"
                  },
                  "value-key": "FNumber"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(client_project_list.value, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.project,
                      value: item.id
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"]), _createElementVNode("span", {
                  class: "client_add iconfont icon-a-zengjiatianjiajiahaoduo",
                  onClick: addClientProject
                })])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[29] || (_cache[29] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "销售员",
                prop: "sale_user"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.sale_user,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.value.sale_user = $event),
                  autocomplete: "off",
                  disabled: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[30] || (_cache[30] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "销售区域",
                prop: "sales_dept_id"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: form.value.sales_dept_id,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => form.value.sales_dept_id = $event),
                  class: "m-2",
                  placeholder: "",
                  style: {
                    "width": "100%"
                  }
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dic_data.sales_area_list, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.name,
                      value: item.id
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[31] || (_cache[31] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "联系人",
                prop: "name"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: form.value.name,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => form.value.name = $event),
                  class: "m-2",
                  placeholder: "",
                  filterable: "",
                  "allow-create": "",
                  style: {
                    "width": "100%"
                  }
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(client_contracts_list.value, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.name,
                      value: item.name
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[32] || (_cache[32] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "手机号码",
                prop: "phone"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.phone,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => form.value.phone = $event),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[33] || (_cache[33] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "预计收入",
                prop: "income"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.income,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => form.value.income = $event),
                  autocomplete: "off",
                  onBlur: price_input,
                  oninput: "value=value.replace(/[^0-9.]/g,'')"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), form.value.opportunity_status != '丢单' ? (_openBlock(), _createBlock(_component_el_col, {
              key: 2,
              span: 12
            }, {
              default: _withCtx(() => [_cache[34] || (_cache[34] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "预计签单时间",
                prop: "signing_time"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                  modelValue: form.value.signing_time,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => form.value.signing_time = $event),
                  type: "datetime",
                  placeholder: "请选择"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          }), _cache[42] || (_cache[42] = _createElementVNode("div", {
            class: "title"
          }, "选填选项", -1)), _createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[35] || (_cache[35] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "来源"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: form.value.source,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => form.value.source = $event),
                  class: "m-2",
                  placeholder: "",
                  style: {
                    "width": "100%"
                  }
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dic_data.source_list, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.full_name,
                      value: item.full_name
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[36] || (_cache[36] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "行业"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: form.value.trade,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => form.value.trade = $event),
                  class: "m-2",
                  placeholder: "",
                  style: {
                    "width": "100%"
                  }
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dic_data.trade_list, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.full_name,
                      value: item.full_name
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[37] || (_cache[37] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "邮箱"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.email,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => form.value.email = $event),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[38] || (_cache[38] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "国家"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.country,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => form.value.country = $event),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[39] || (_cache[39] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "地址"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.address,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => form.value.address = $event),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_cache[40] || (_cache[40] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "客户需求"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  type: "textarea",
                  modelValue: form.value.demand,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => form.value.demand = $event),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_cache[41] || (_cache[41] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "解决方案"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  type: "textarea",
                  modelValue: form.value.solution,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => form.value.solution = $event),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"]), _createElementVNode("div", null, [_createVNode(_component_good_list_table, {
          goods: goods_list.value,
          onChange_goods: handle_goods,
          type: 'business',
          onIncomeChange: _cache[19] || (_cache[19] = $event => countIncome(goods_list.value)),
          isEdit: true
        }, null, 8, ["goods"])])]),
        _: 1
      }, 8, ["modelValue", "title"]), _createVNode(_component_select_data, {
        onClose: _cache[22] || (_cache[22] = $event => is_show_dialog.value = false),
        isShow: is_show_dialog.value,
        data_type: data_type.value,
        key_word: key_word.value,
        dialog: "",
        onOnSelectItem: get_select_item
      }, null, 8, ["isShow", "data_type", "key_word"]), showDialog.value ? (_openBlock(), _createBlock(_component_client_project_dialog, {
        key: 0,
        isShow: showDialog.value,
        onOnClose: handle_close_client,
        id: cur_client_id.value
      }, null, 8, ["isShow", "id"])) : _createCommentVNode("", true)]);
    };
  }
};